import type { EnvironmentVariableFieldProps } from "../../types/skyward/treebrowse";
import { defineBaseFieldComponent } from "./baseField";
import * as Classes from "./classes";

export const EnvironmentVariableField = defineBaseFieldComponent<EnvironmentVariableFieldProps, ReturnType<typeof formatField>>(
    {
        name: "environmentVariableField",
        additionalRowAttributes: () => ({ class: [Classes.treebrowserow, Classes.jsDraggable, Classes.fieldspan] }),
        nameCell:(field)=><td><span>{field.displayName}</span></td>,
        parametersCell: ()=> <td><input type="checkbox" disabled={true} checked={false} /></td>,
        typeIcon: (field) => field.svgClass,
        fieldKey: (field) => field.fieldName,
        formatField:formatField,
    }
);

function formatField(field: EnvironmentVariableFieldProps)
{

    const result =
    {
        // These correspond to old data- attribute names, used in reporting and elsewhere
        fieldType: field.format,
        fieldName: field.fieldName,

        // Used by reporting.js
        pageSectionColumnType: "EnvironmentVariable",
        // Also used by reporting.js.  For some reason these are always 0.
        fieldWidth: undefined,
        fieldHeight: undefined
    };
    return result;
}
